import PropTypes from 'prop-types';
import classNames from 'classnames';
import { alpha, makeStyles } from '@material-ui/core';
import ActionButton from '../../../../../actionButton';
import TextBoxWithTooltip from '../../../../../textBoxWithTooltip';
import { isArrayEmpty } from '../../../../../../../utility/helpers';
import { ACTION_BUTTON_TYPES } from '../../../../../actionButton/config';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    header: {
      cursor: 'default',
      display: 'grid',
      paddingTop: spacing(2),
      backgroundColor: primary.white,
      alignItems: 'center',
      justifyContent: 'space-between',
      gridTemplateColumns:
        'minmax(36px, 36px) minmax(100px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) minmax(160px, 170px) minmax(60px, 60px)',
      boxSizing: 'border-box',
      borderBottom: `1px solid ${primary.bluish7}`,
      '& $dragButton': {
        opacity: 0,
        transition: 'opacity .3s ease',
        paddingTop: 0,
        height: '100%',
        alignItems: 'start',
        top: '-1px',
        position: 'relative',
      },
      '&:hover': {
        boxShadow: `0px 2px 8px 0px ${alpha(primary.black, 0.17)}`,
        transition: 'box-shadow .3s ease',
        borderRadius: 8,
        zIndex: 999,
        position: 'relative',
        '& $dragButton': {
          opacity: ({ isVisible }) => {
            return isVisible ? 1 : 0;
          },
          transition: 'opacity .3s ease',
          cursor: ({ isVisible }) => {
            return isVisible ? 'pointer' : 'grabbing';
          },
        },
      },
      '&:active': {
        boxShadow: `0px 2px 8px 0px ${alpha(primary.black, 0.17)}`,
        transition: 'box-shadow .3s ease',
        borderRadius: 8,
        zIndex: 999,
        position: 'relative',
        '& > div:first-child': {
          opacity: 1,
          transition: 'opacity .3s ease',
        },
      },
    },
    headerNoSalary: {
      gridTemplateColumns:
        'minmax(380px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) 16px',
    },
    headerNoSalaryWithEdit: {
      gridTemplateColumns:
        'minmax(36px, 36px) minmax(380px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) 45px',
    },
    headerNoSalaryWithDelete: {
      gridTemplateColumns:
        'minmax(380px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) 45px',
    },
    headerSalary: {
      gridTemplateColumns:
        'minmax(100px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) minmax(160px, 170px) 30px',
    },
    headerSalaryWithEdit: {
      gridTemplateColumns:
        'minmax(36px, 36px) minmax(100px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) minmax(160px, 170px) 60px',
    },
    headerSalaryWithDelete: {
      gridTemplateColumns:
        'minmax(100px, 1fr) minmax(185px, 185px) minmax(70px, 180px) minmax(60px, 180px) minmax(160px, 170px) 60px',
    },
    // rootNoSalary: {
    //   gridTemplateColumns:
    //     'minmax(30px, 30px) minmax(100px, 1fr) minmax(190px, 190px) minmax(70px, 190px) minmax(60px, 180px) minmax(44px, 44px)',
    // },
    // readOnlyRoot: {
    //   width: '100%',
    //   gridTemplateColumns:
    //     'minmax(0px, 0px) minmax(384px, 1051px) minmax(238px, 348px)',
    // },
    // headerDisabled: {
    //   gridTemplateColumns:
    //     'minmax(0px, 0px) minmax(100px, 1fr) minmax(190px, 190px) minmax(70px, 190px) minmax(60px, 180px) minmax(180px, 180px) minmax(30px, 40px)',
    // },
    // disabledNoSalary: {
    //   gridTemplateColumns:
    //     'minmax(0px, 0px) minmax(100px, 1fr) minmax(190px, 190px) minmax(70px, 190px) minmax(60px, 180px) minmax(30px, 40px)',
    // },
    item: {
      boxSizing: 'border-box',
      padding: spacing(4, 2),
      [breakpoints.up('xLg')]: {
        padding: spacing(4),
      },
    },
    description: {
      boxSizing: 'border-box',
      minWidth: 0,
      height: '100%',
      padding: spacing(0, 4, 4, 0.5),
    },
    readOnlyDescription: {
      padding: spacing(0, 4, 4, 9),
    },
    actions: {
      boxSizing: 'border-box',
      cursor: 'default',
      height: '100%',
      padding: spacing(0, 2),
      [breakpoints.up('xLg')]: {
        padding: spacing(0, 2),
      },
    },
    peopleAndSalary: {
      width: 'fit-content',
      position: 'relative',
      height: '100%',
    },
    salary: {
      paddingLeft: spacing(0.4),
      maxWidth: 180,
    },
    dragButton: {
      position: 'relative',
      width: 22,
      height: 22,
      flexShrink: 0,
      marginLeft: spacing(2),
      marginRight: spacing(1.5),
      zIndex: 11,
      overflow: 'visible',
      '& button': {
        width: 22,
        height: 22,
      },
      '$header:hover': {
        opacity: ({ isVisible }) => {
          return isVisible ? 1 : 0;
        },
        transition: 'opacity .3s ease',
        cursor: ({ isVisible }) => {
          return isVisible ? 'pointer' : 'grabbing';
        },
      },
    },
    dragIcon: {
      width: 8,
      height: 14,
    },
    dragTooltipLabel: {
      fontFamily: 'ProximaNova-Regular',
    },
    range: {
      boxSizing: 'border-box',
      paddingLeft: spacing(4),
      height: '100%',
      paddingTop: spacing(8.5),
      position: 'relative',
    },
    attributes: {
      height: '100%',
      position: 'relative',
    },
    cell: {
      marginLeft: 0,
      fontSize: 14,
      lineHeight: '18px',
      paddingBottom: spacing(4),
    },
  })
);

const Level = ({
  translations,
  currency = '',
  level,
  dragRef = () => {},
  dragProps = null,
  isReadOnly,
  canEdit = false,
  canDelete = false,
  hasSalarySettings = false,
  isVisible = false,
}) => {
  const classes = useStyles({ isVisible });
  const { description, attributes, range, people, actions } = level;
  const hasSalaryRange = level.minSalary && level.maxSalary;

  const salary = hasSalaryRange
    ? `${currency} ${level.minSalary} - ${currency} ${level.maxSalary}`
    : '-';

  return (
    <div
      ref={dragRef}
      className={classNames(classes.header, {
        [classes.headerNoSalary]: !hasSalarySettings && !canEdit && !canDelete,
        [classes.headerNoSalaryWithEdit]: !hasSalarySettings && canEdit,
        [classes.headerNoSalaryWithDelete]:
          !hasSalarySettings && !canEdit && canDelete,
        [classes.headerSalary]: hasSalarySettings && !canEdit && !canDelete,
        [classes.headerSalaryWithEdit]: hasSalarySettings && canEdit,
        [classes.headerSalaryWithDelete]:
          hasSalarySettings && !canEdit && canDelete,
        // [classes.rootNoSalary]: !hasSalarySettings,
        // [classes.headerDisabled]: !canManageLeveling,
        // [classes.disabledNoSalary]: !hasSalarySettings && !canManageLeveling,
        [classes.readOnlyRoot]: isReadOnly,
      })}
      {...(dragProps ? { ...dragProps.draggableProps } : {})}
    >
      {!isReadOnly && canEdit && (
        <ActionButton
          className={classes.dragButton}
          iconClass={classes.dragIcon}
          tooltipLabelClass={classes.dragTooltipLabel}
          type={ACTION_BUTTON_TYPES.DRAG}
          tooltipText={translations.levelDragTooltip}
          {...(dragProps ? { ...dragProps.dragHandleProps } : {})}
        />
      )}
      <div
        className={classNames(classes.item, classes.description, {
          [classes.readOnlyDescription]: isReadOnly || !canEdit,
        })}
      >
        {description}
      </div>
      {!isReadOnly && (
        <>
          <div className={classes.attributes}>
            {!isArrayEmpty(attributes) && (
              <TextBoxWithTooltip
                className={classes.cell}
                variant="h5"
                text={translations.attributes}
              />
            )}
            {attributes}
          </div>
          <div className={classes.range}>{range}</div>
          <div className={classes.peopleAndSalary}>{people}</div>
          {hasSalarySettings && (
            <div className={classes.peopleAndSalary}>
              <TextBoxWithTooltip
                className={classes.salary}
                variant="subtitle2"
                text={salary}
              />
            </div>
          )}
        </>
      )}
      {(canEdit || canDelete) && !isReadOnly && (
        <div className={classes.actions}>{actions}</div>
      )}
    </div>
  );
};

Level.propTypes = {
  translations: PropTypes.object.isRequired,
  isVisible: PropTypes.bool,
  level: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  dragProps: PropTypes.object,
  dragRef: PropTypes.func,
  currency: PropTypes.string,
  hasSalarySettings: PropTypes.bool,
};

export default Level;
